import { Box, Typography } from "@mui/material";
import { ReactElement } from "react";
import colors from "../../colors";
import CabinetPage from "../../components/Common/CabinetPage";
import MeetingLogContainer from '../../components/Schedule/MeetingLog';
import CreateMeetingButton from "../../components/Schedule/CreateMeetingButton/CreateMeetingButton";
import { isLargeFormatDevice } from "../../utils/screenSizeUtils";


const MeetingLog = (): ReactElement => {
  return (
    <CabinetPage
      pageName={'Meetings'}
      headerContent={<Box
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          paddingLeft: 2
        }}>
        <Typography variant="h1">
          One-Off Meetings
        </Typography>
        {isLargeFormatDevice() && (
          <CreateMeetingButton buttonTitle="Create" />
        )}
      </Box>
      }
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          padding: 5,
          paddingTop: 4
        }}>
        <Typography variant="h2" color={colors.black600} sx={{
          fontWeight: "regular"
        }}>
          Organize and keep track of Meetings you are scheduling.
        </Typography>

        <MeetingLogContainer />
      </Box>
    </CabinetPage>
  );
};

export default MeetingLog;
